<section id="contact" class="contact-section">
  <h2>Contact Us</h2>
  <p>We’d love to connect with you! Reach out for collaborations or project inquiries.</p>

  <div class="contact-info">

    <a href="tel:+917517783691" class="contact-item">
      <i class="fas fa-phone"></i>
      <span>+91 7517783691</span>
    </a>

   <a href="https://mail.google.com/mail/?view=cm&fs=1&to=info@asappsoftwaresolutions.com" class="contact-item" target="_blank">
    <i class="fas fa-envelope"></i>
    <span>info&#64;asappsoftwaresolutions.com</span>
</a>


    <a href="https://linkedin.com/in/prasad-amrutkar" class="contact-item" target="_blank">
      <i class="fab fa-linkedin"></i>
      <span>linkedin.com/in/prasad-amrutkar</span>
    </a>

  </div>
</section>

<footer>
  <p>© 2025 ASAPP SOFTWARE SOLUTIONS | All Rights Reserved</p>
</footer>

<!-- Font Awesome Icons -->
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />

